
  const dom = {
    closeButton: $('.qty-error_close'),
    modal: $('.qty-error_modal'),
    modalProductTitle: $('.qtyError_product')

  };

  const MaxProductQuantity = 5;

  const checkQuantityLimit = (addQuantity,productID) => {
      jQuery.getJSON('/cart.js', function(cart) {
        console.log('checking cart');
        let items = cart.items;
        for(var i=0; i < items.length; i++){
          console.log('for loop');
          let currentqty = parseInt(items[i].quantity);
          let newQuantity = currentqty + parseInt(addQuantity);
          console.log('new quantitty = ' + newQuantity);
          console.log('input id = ' + productID);
          console.log('current id = '+ items[i].id)
          if(items[i].id == productID && newQuantity > 5){
            console.log('rejected');
            return false;
          }
        }
      } );
  }

  const openQtyErrorModal = (prodName) => {
    dom.modal.addClass('qty-error_modal--visible');
    if(prodName){
      dom.modalProductTitle.text(prodName);
    }
  }

  const bindUIActions = () => {
    dom.closeButton.on('click', function() {
      dom.modal.removeClass('qty-error_modal--visible');
      });
  };

  export const initQuantityLimits = () => {
    bindUIActions();
    window.openQtyErrorModal = openQtyErrorModal;
    window.checkQuantityLimit = checkQuantityLimit;
    window.MaxProductQuantity = MaxProductQuantity;
  };

  export default initQuantityLimits;